/* eslint-disable react/no-unknown-property */
import React from 'react';
import { Card } from '@doveit/bricks';
import Table, { DEFAULT_TABLE_PAGE_SIZE } from '../../../components/table/Table';
import { AreaType } from '../../../domain/types';
import { AgentsPerArea } from '../../models/AgentsPerArea';
import * as styles from './AgentAreasList.style';
import { agentAreasListColumns } from './columnsSettings';

export interface AgentAreasListProps {
  data: AgentsPerArea[],
  areaType?: AreaType,
  dataFor: string,
}

const AgentAreasList: React.FC<AgentAreasListProps> = ({
  areaType = AreaType.ZIP_CODE,
  data,
  dataFor,
}) => (
  <div css={styles.table}>
    {data.length > 0 && (
      <h4 css={styles.tableTitle}>
        Risultati per: <strong>{dataFor}</strong>
      </h4>
    )}

    <Card>
      <Card.Content>
        <Table
          data={data}
          columns={agentAreasListColumns(areaType)}
          pageable={data.length > DEFAULT_TABLE_PAGE_SIZE}
          sortable
          filterable
        />
      </Card.Content>
    </Card>
  </div>
);

export default AgentAreasList;
